import { createVanIconComponent } from "./van"

const Wechat = createVanIconComponent("wechat")
export default Wechat
